import { useFormContext } from 'react-hook-form';
import { Checkbox } from '~/components/ui/forms/Checkbox';
import { TextAreaInput } from '~/components/ui/forms/text-area-input';
import { TextInput } from '~/components/ui/forms/text-input';
import type { ProjectFormValues } from '~/utils/modules/project';

export function ProjectFormFields() {
  const { register } = useFormContext<ProjectFormValues>();

  return (
    <div className="space-y-2">
      <TextInput {...register('name')} label="Name" required />
      <TextAreaInput
        {...register('description')}
        label="Description"
        required
      />
      <TextAreaInput {...register('comments')} label="Comments" />
      <Checkbox {...register('hidden')} label="Hidden" />
    </div>
  );
}
